import React from 'react';

import { useTimesheetData, useTimesheetEdit } from 'src/features/timesheets/providers';
import { IconButton, RefreshIcon } from 'src/shared/components';

export const TimesheetRefresh = () => {
  const { onRefetch, loadingTimesheetSummary } = useTimesheetData();
  const { loading } = useTimesheetEdit();

  return (
    <IconButton onClick={onRefetch} disabled={loading || loadingTimesheetSummary}>
      <RefreshIcon />
    </IconButton>
  );
};
